"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchContainsChanges = exports.isPatchable = void 0;
function isPatchable(object) {
    if (!object) {
        return false;
    }
    return !!object.patch;
}
exports.isPatchable = isPatchable;
function patchContainsChanges(patch, model, context) {
    const patched = model.patch(patch);
    return JSON.stringify(patched.encode(context)) != JSON.stringify(model.encode(context));
}
exports.patchContainsChanges = patchContainsChanges;
//# sourceMappingURL=Patchable.js.map